import { FiMoon, FiSun } from "react-icons/fi";
import type { ClipTheme } from "../hooks/useClipTheme";

interface ThemeToggleProps {
  theme: ClipTheme;
  onToggle: () => void;
}

export function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  const nextTheme = theme === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      className="clip-theme-toggle"
      data-theme={theme}
      onClick={onToggle}
      aria-label={`Switch to ${nextTheme} mode`}
      title={`Switch to ${nextTheme} mode`}
    >
      <span className="clip-theme-toggle-track" aria-hidden="true">
        <FiMoon className="clip-theme-moon" />
        <FiSun className="clip-theme-sun" />
        <i className="clip-theme-toggle-thumb" />
      </span>
    </button>
  );
}
